import React from 'react';
import { Link } from 'react-router-dom';
// Constants
import {
  CompanyTagLine,
  CompanyName,
  CompanyEmailAddress,
  LocationCity,
  LocationCountry,
} from '../../utils/Constants';
// Components
import FooterSocialCTA from './FooterSocialCTA';
// Data
import { FooterLinksArray } from '../../utils/data/FooterData';
import { MainServicesArray } from '../../utils/data/CompanyData';

function FooterComponent() {
  return (
    <footer
      className='grid bg-alt-background w-full overflow-hidden py-6 md:py-12 px-6 md:px-20 font-poppins'
      role='contentinfo'
      aria-label='Website footer'
    >
      <div
        className='grid lg:grid-cols-3 mx-auto gap-6 bg-colour1 dark:bg-colour2 px-2 md:px-10 py-8 w-full'
        itemScope
        itemType='https://schema.org/Organization'
      >
        {/* Logo section */}
        <section className='grid h-fit my-auto gap-4 py-2 w-full' aria-labelledby='footer-branding'>
          <div className='grid items-center justify-center'>
            <span
              id='footer-branding'
              className='text-colour5 font-titleFont hover:brightness-90'
              itemProp='name'
            >
              {CompanyName}
            </span>
          </div>
          <div className='text-center'>
            <p className='text-sm' itemProp='slogan'>{CompanyTagLine}</p>
          </div>
          <div className='text-colour5' role='group' aria-label='Social media links'>
            <FooterSocialCTA />
          </div>
        </section>

        {/* Footer links */}
        <section className='grid grid-cols-2 px-2 gap-2 w-full'>
          <section
            className='grid grid-rows-reg gap-y-2 w-full lg:justify-center text-center'
            aria-labelledby='footer-quick-links'
          >
            <div className='text-left h-fit w-full'>
              <h6 id='footer-quick-links'>Quick Links</h6>
              <div className='border-b-2 border-solid border-colour2 pt-2'></div>
            </div>

            {/* Treat links as a nav landmark for screen readers */}
            <nav aria-labelledby='footer-quick-links'>
              <ul className='text-left w-full'>
                {FooterLinksArray.map((link, index) => {
                  return (
                    <li key={index}>
                      <Link
                        to={link.route}
                        aria-label={`${link.name} page`}
                        className='text-sm'
                        onClick={() => {
                          window.scroll(0, 0);
                        }}
                        // NOTE: aria-current on <Link> can be invalid if passed a function (NavLink handles this).
                        // Keeping it semantic-safe:
                        aria-current={undefined}
                      >
                        {link.name}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </nav>
          </section>

          <section
            className='grid grid-rows-reg gap-y-2 justify-center text-center'
            aria-labelledby='footer-services-heading'
          >
            <div className='text-left h-fit'>
              <h6 id='footer-services-heading'>Services</h6>
              <div className='border-b-2 border-solid border-colour2 pt-2'></div>
            </div>
            <ul className='text-left' aria-label='Service list'>
              {MainServicesArray.map((service, index) => {
                return (
                  <li key={index} className='text-sm'>
                    {service.title}
                  </li>
                );
              })}
            </ul>
          </section>
        </section>

        {/* Social media links */}
        <section
          className='grid grid-rows-reg gap-y-2 w-fit px-2'
          aria-labelledby='footer-contact-heading'
        >
          <section className='text-left'>
            <h6 id='footer-contact-heading'>Contact me at</h6>
            <div className='border-b-2 border-solid border-colour2 pt-2'></div>
          </section>

          {/* Use <address> for semantics; styling unchanged */}
          <address className='grid gap-1 h-fit text-sm not-italic' itemProp='address' itemScope itemType='https://schema.org/PostalAddress'>
            {/* Email */}
            <div>
              <a href={`mailto:${CompanyEmailAddress}`} aria-label={`Email ${CompanyName}`} itemProp='email'>
                <p>
                  <span className='font-semibold'>Email: </span>
                  {CompanyEmailAddress}
                </p>
              </a>
            </div>
            {/* Phone */}
            {/* <div>
              <a href={`tel:${CompanyPhoneNumber}`} aria-label={`Call ${CompanyName}`} itemProp='telephone'>
                <p>
                  <span className='font-semibold'>Phone: </span>+{CompanyPhoneNumber} (UK)
                </p>
              </a>
            </div> */}
            {/* Short address */}
            <div>
              <p>
                <span className='font-semibold'>Location: </span>
                <span itemProp='addressLocality'>{LocationCity}</span>,{' '}
                <span itemProp='addressCountry'>{LocationCountry}</span>
              </p>
            </div>
          </address>
        </section>
      </div>
    </footer>
  );
}

export default FooterComponent;
